// extracted by mini-css-extract-plugin
export default {"banner":"style-module--banner--ekhW3","image":"style-module--image---0Zp3"};